import { useMemo } from "react";

import { useApi } from "hooks/useApi";
import { ApiEndpoint, baseFetcher } from "utils/baseFetcher";

export const BACKGROUND_COLORS = {
  score: [
    { minValue: 1, backgroundClass: "bg-[#4DB364]/0" },
    { minValue: 2, backgroundClass: "bg-[#4DB364]/20" },
    { minValue: 3, backgroundClass: "bg-[#4DB364]/40" },
    { minValue: 4, backgroundClass: "bg-[#4DB364]/80" },
    { minValue: 5, backgroundClass: "bg-[#4DB364]" },
  ],
  zScore: [
    { minValue: 0, backgroundClass: "bg-[#ac334b]/0" },
    { minValue: 1, backgroundClass: "bg-[#ac334b]/20" },
    { minValue: 2, backgroundClass: "bg-[#ac334b]/40" },
    { minValue: 3, backgroundClass: "bg-[#ac334b]/60" },
    { minValue: 4, backgroundClass: "bg-[#ac334b]/80" },
    { minValue: 5, backgroundClass: "bg-[#ac334b]" },
    { minValue: 6, backgroundClass: "bg-[#ac334b]" },
    { minValue: 7, backgroundClass: "bg-[#ac334b]" },
    { minValue: 8, backgroundClass: "bg-[#ac334b]" },
    { minValue: 9, backgroundClass: "bg-[#ac334b]" },
    { minValue: 10, backgroundClass: "bg-[#ac334b]" },
  ],
};

export enum TimeUnit {
  Quarter = "m3",
  Year = "y1",
  Year5 = "y5",
}

export const TIME_UNIT_LABELS = {
  [TimeUnit.Quarter]: "3M",
  [TimeUnit.Year]: "1Y",
  [TimeUnit.Year5]: "5Y",
};

export const relativeValuePairUrl = (pairId: string, options: any) => {
  const url = new ApiEndpoint(`/api/v2/relative-value-pairs/${pairId}`);
  url.searchParams.append(
    "include",
    "latest-relative-value-pair-history,entity-x,entity-y"
  );

  Object.keys(options).forEach((key) => {
    url.searchParams.append(key, options[key]);
  });

  return url.href;
};

export const relativeValuePairsUrl = (page: any, options: any) => {
  const url = new ApiEndpoint(`/api/v2/relative-value-pairs`);
  url.searchParams.append("page[number]", page);
  url.searchParams.append(
    "include",
    "latest-relative-value-pair-history,entity-x,entity-y"
  );

  Object.keys(options).forEach((key) => {
    url.searchParams.append(key, options[key]);
  });

  return url.href;
};

export const useMaxZScore = () => {
  const { data: maxZScoreData } = useApi(
    relativeValuePairsUrl(1, {
      sort: "-z-score",
      "page[size]": 1,
      "fields[relative-value-pair-histories]": "z-score",
    }),
    baseFetcher
  );
  const maxZScore = useMemo(
    () =>
      Math.ceil(
        Math.abs(
          maxZScoreData?.data?.[0]?.latestRelativeValuePairHistory?.zScore
        )
      ),
    [maxZScoreData]
  );

  return { maxZScore };
};
